/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SourceInputs */

const cs_field_source = /** @type {(inputs: Field_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj`)
};

const en_field_source = /** @type {(inputs: Field_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Field_SourceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_source = /** @type {((inputs?: Field_SourceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SourceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_source(inputs)
	return cs_field_source(inputs)
});